import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Der Inhalt liegt jetzt unter der aelteren, bei Google bereits
 * rankenden Adresse /blog/shopify-seo-optimierung-guide.
 */
export const Route = createFileRoute("/ratgeber/shopify-seo")({
  beforeLoad: () => {
    throw redirect({ to: "/blog/shopify-seo-optimierung-guide", statusCode: 301 });
  },
  component: () => null,
});
